import { BASE_URL } from "@utils/constants";
import {
  addTranslatorAdminDetails,
  addAssignedProjects,
  addAssignedFolders,
  addAssignedFiles,
  addTranslators,
  setSelectedFile,
  setSentenceTableData,
  setAssignedLanguages,
  setAssignedLanguagesToUser,
} from "@store/slices/translatorAdminSlice";
import { addSentences } from "@store/slices/dashboardSlice";
import { createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "@/services/api/apiClient";

export const fetchAllTranslatorAdminDetails = () => async (dispatch, getState) => {
  const state = getState();
  const { userId,token } = state.auth;
  try {
    const data = await apiClient(
      BASE_URL + `api/translatorAdmin/projects?translatorAdminId=${userId}`,
      {
        method: 'GET',
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("Fetched translator admin details:", data.data);
    dispatch(addTranslatorAdminDetails(data.data));
    return data.data;
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
};

export const fetchAllTranslators = (languageId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const data = await apiClient(
      BASE_URL + `api/translatorAdmin/getTU?languageId=${languageId}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    dispatch(addTranslators(data.data));
    return data;
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
};

export const assignTranslatorAPI = (assignments) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const fileId = state.fileMeta.fileId;

    // Ensure assignments is an array
    if (!Array.isArray(assignments)) {
      throw new Error("Assignments must be an array");
    }

    // Process each assignment sequentially
    const results = [];
    for (const assignment of assignments) {
      const data = await apiClient(BASE_URL + "api/translatorAdmin/assignTU", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({
          fileId: fileId, // Use fileId from fileMeta slice
          sourceLanguageId: assignment.sourceLanguageId,
          targetLanguageId: assignment.targetLanguageId,
          translatorUserId: assignment.translatorUserId,
          translatorAdminId: assignment.translatorAdminId,
        }),
      });

      results.push(data);
    }

    // Fetch updated details after all assignments are processed
    dispatch(fetchAllTranslatorAdminDetails());

    return results; // Return array of API responses
  } catch (error) {
    console.error("Error assigning translators:", error);
    throw error; // Propagate error to the caller
  }
};

export const fetchSelectedFileData = (fileId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;
    const myHeaders = new Headers();
    // myHeaders.append("credentials", "include");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      headers: myHeaders,
      credentials: "include",
    };
    const result = await apiClient(
      BASE_URL + `api/user/languages`,
      requestOptions
    );
    const data = result.data ? result.data : result;
    console.log("fetchSelectedFileData: data = ", data);
    dispatch(setSelectedFile(data));
    return data;
  } catch (error) {
    console.error("Error fetching File data:", error);
  }
};

export const fetchAllInProgressProjects = (keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  const state = getState();
  const { role, token } = state.auth;
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = {
    headers: myHeaders,
    credentials: "include",
  };
  try {
    let url;
    switch (role) {
      case "TRANSLATOR ADMIN":
        url = `api/translatorAdmin/projects?translatorAdminId=${state.auth.userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
        console.log("switch : ", role);
        break;
      case "TRANSLATOR USER":
        url = `api/translatorUser/projects?translatorUserId=${state.auth.userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
        console.log("switch : ", role);
        break;
      case "DEVNAGRI_VENDOR_ADMIN":
        url = "api/devnagriValidatorAdmin/getAssignedProjects";
        break;
    }

    const data = await apiClient(BASE_URL + url, requestOptions);
    console.log("Fetched projects:", data.data);
    dispatch(addAssignedProjects(data.data));
    return data.data;
  } catch (error) {
    console.error("Error fetching projects:", error);
  }
};

// getInProgressFoldersByProject
export const fetchInProgressFolders = (projectId, keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
  if (projectId === undefined || projectId === null || projectId === "undefined") {
    console.error("Invalid project ID:", projectId);
    return [];
  }
  const state = getState();
  const { role, token } = state.auth;
  const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
  const requestOptions = {
    headers: myHeaders,
    credentials: "include",
  };
  try {
    let url;
    switch (role) {
      case "TRANSLATOR ADMIN":
        url = `api/translatorAdmin/folders?projectId=${projectId}&translatorAdminId=${state.auth.userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
        break;
      case "TRANSLATOR USER":
        url = `api/translatorUser/folders?projectId=${projectId}&translatorUserId=${state.auth.userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
        break;
    }
    const data = await apiClient(BASE_URL + url, requestOptions);
    console.log("Fetched folders:", data.data);
    dispatch(addAssignedFolders(data.data));
    return data.data;
  } catch (error) {
    console.error("Error fetching Folders:", error);
  }
};

export const fetchInProgressFiles =
  (folderId, keyword = '', page = 0, size = 10) => async (dispatch, getState) => {
    const state = getState();
    const { role, token } = state.auth;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);
    const requestOptions = {
      headers: myHeaders,
      credentials: "include",
    };
    try {
      let url;
      switch (role) {
        case "TRANSLATOR ADMIN":
          url = `api/translatorAdmin/files?folderId=${folderId}&translatorAdminId=${state.auth.userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
          break;
        case "TRANSLATOR USER":
          url = `api/translatorUser/files?folderId=${folderId}&translatorUserId=${state.auth.userId}&searchKeyword=${keyword}&page=${page}&size=${size}`;
          break;
      }

      const data = await apiClient(BASE_URL + url, requestOptions);
      console.log("Fetched files:", data.data);
      dispatch(addAssignedFiles(data.data));
      return data.data;
    } catch (error) {
      console.error("Error fetching projects:", error);
    }
  };

// New thunk action for sending files to vetters
export const sendFileToVetter = (fileId, language) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { token } = state.auth;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      credentials: "include",
      body: JSON.stringify({
        fileId: fileId,
        sourceLanguageId: 2,
        targetLanguageId: language,
        status: "SENT_TO_VETTER"
      })
    };

    const data = await apiClient(
      BASE_URL + "api/translatorAdmin/assignVA",
      requestOptions
    );

    // Refresh the file data
    dispatch(fetchSelectedFileData(fileId));

    return data;
  } catch (error) {
    console.error("Error sending file to vetter:", error);
    throw error;
  }
};

// New thunk action for assigning to validator admin
export const assignToValidatorAdmin = (fileId, fileName, translations) => async (dispatch, getState) => {
  try {

    if (!fileId || !fileName) {
      throw new Error('File ID and File Name are required');
    }

    if (!Array.isArray(translations) || translations.length === 0) {
      throw new Error('Translations array is required and must not be empty');
    }

    const state = getState();
    const { token } = state.auth;

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${token}`);

    // Structure the request body to match TranslatorAssignmentRequest DTO
    const requestBody = {
      transDetails: translations.map(trans => {
        console.log("lid" + trans.languageName);
        // if (!trans.languageId || !trans.languageName || !trans.translatorId || !trans.translatorName) {
        //   throw new Error('Each translation must have languageId, languageName, translatorId, and translatorName');
        // }
        return {
          languageId: trans.languageId,
          languageName: trans.languageName,
          translatorId: trans.translatorId,
          translatorName: trans.translatorName
        };
      }),
      fileDetails: {
        fileId: fileId,
        fileName: fileName
      }
    };

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      credentials: "include",   
      body: JSON.stringify(requestBody)
    };

    const data = await apiClient(
      BASE_URL + "api/translations/assignToValidatorAdmin",
      requestOptions
    );


    // Refresh the translator admin details after assignment
    dispatch(fetchAllTranslatorAdminDetails());

    return data;
  } catch (error) {
    console.error("Error assigning to validator admin:", error);
    throw error;
  }
};

export const fetchAssignedFileDetails = createAsyncThunk(
  "translation/fetchAssignedFileDetails",
  async ({ fileId, translatorUserId }, { dispatch,getState }) => {
    try {
      const state = getState();
      const { role, token, userId } = state.auth;

      let url;
      if (role === "TRANSLATOR USER") {
        // Use translator user endpoint
        url = `${BASE_URL}api/translatorUser/filesByfileId?fileId=${fileId}&translatorUserId=${translatorUserId || userId}`;
      } else {
        // Use translator admin endpoint - use current user's ID as translatorAdminId
        url = `${BASE_URL}api/translatorAdmin/filesByFileId?fileId=${fileId}&translatorAdminId=${userId}`;
      }

      const data = await apiClient(url, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      });

      return data.data || data;
    } catch (error) {
      throw error;
    }
  }
);

// Fetch sentences for translator users
export const fetchSentencesForTranslator = (fileId, sourceId, targetId, translatorUserId, clickReject, rejectedTab) => async (dispatch, getState) => {

  try {
    const state = getState();
    const { token, userId } = state.auth;

    // Use the new API endpoint with required parameters
    const url = clickReject ? (rejectedTab === 'me' ? `${BASE_URL}api/translatorUser/TURejectedSentences?fileId=${fileId}` : `${BASE_URL}api/translatorUser/VURejectedSentences?fileId=${fileId}&sourceId=${sourceId}&targetId=${targetId}`)
      : `${BASE_URL}api/translatorUser/sentences?fileId=${fileId}&sourceId=${sourceId}&targetId=${targetId}&translatorUserId=${translatorUserId || userId}`;
    console.log("🚀 Making API call to:", url);

    const data = await apiClient(url, {
      method: "GET",
      credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
    });

    console.log("✅ Sentences API response:", data);

    if (data.status === "success") {
      // Filter out duplicate sentences based on sentenceId
      const uniqueSentences = data.data.reduce((acc, sentence) => {
        const existingIndex = acc.findIndex(s => s.sentenceId === sentence.sentenceId);
        if (existingIndex === -1) {
          // Add new sentence
          acc.push(sentence);
        } else {
          // If duplicate found, keep the one with non-empty translatedText or the first one
          const existing = acc[existingIndex];
          if (sentence.translatedText && !existing.translatedText) {
            acc[existingIndex] = sentence; // Replace with the one that has translation
          }
        }
        return acc;
      }, []);

      console.log("✅ Filtered unique sentences:", uniqueSentences);

      // Dispatch to the dashboard slice since that's where sentences are stored
      dispatch(addSentences(uniqueSentences));
      console.log("✅ Sentences dispatched to Redux");
    }else {
      console.error("Failed to fetch sentences:", result.message);
      dispatch(addSentences([])); // Clear sentences on error
    }

    return data;
  } catch (error) {
    console.error("❌ Error fetching sentences for translator:", error);
    throw error;
  }
};


export const fetchAssignedLanguages = (fileId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    console.log("Fetching assigned languages for fileId:", fileId);
    const data = await apiClient(
      BASE_URL + `api/translatorAdmin/file/TAassignedLanguages?fileId=${fileId}&translatorAdminId=${state.auth.userId}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("Assigned languages for admin:", data);
    dispatch(setAssignedLanguages(data.data))
    return data;
  } catch (error) {
    console.error("Error fetching assigned languages to admin:", error);
    return { data: [] };
  }
};

export const fetchAssignedLanguagesToTranslator = (fileId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    console.log("Fetching assigned languages for fileId:", fileId);
    const data = await apiClient(
      BASE_URL + `api/translatorAdmin/file/TUassignedLanguages?fileId=${fileId}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("Assigned languages for user:", data.data);
    dispatch(setAssignedLanguagesToUser(data.data || []))
    return data;
  } catch (error) {
    console.error("Error fetching assigned languages for user:", error);
    return { data: [] };
  }
};


export const fetchKnownLanguages = (userId) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const data = await apiClient(
      BASE_URL + `api/user/knownLanguages?userId=${userId}`,
      {
       credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    console.log("Known languages for user:", data.data);
    return data;
  } catch (error) {
    console.error("Error fetching known languages:", error);
    return { data: [] };
  }
};

// Thunk to assign file to Validator Admin
export const assignFileToValidatorAdmin = ({ fileId, sourceLanguageId, targetLanguageId }) => async (dispatch, getState) => {
  try {
    const state = getState();
    const token = state.auth.token;
    const data = await apiClient(
      BASE_URL + "api/translatorAdmin/assignVA",
      {
        method: "PATCH",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ fileId, sourceLanguageId, targetLanguageId }),
      }
    );
    
    return data;
  } catch (error) {
    console.error("Error assigning file to Validator Admin:", error);
    return error;
  }
};

export const fetchFileAssignmentDetails = ({ fileId, translatorAdminId }) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  try {
    const data = await apiClient(
      BASE_URL + `api/translatorAdmin/filesByFileId?fileId=${fileId}&translatorAdminId=${translatorAdminId}`,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    return data.data && data.data[0];
  } catch (error) {
    console.error('Error fetching file assignment details:', error);
    return null;
  }
};

export const fetchSentenceTableData = ({ fileId, sourceId, targetId, translatorAdminId, status }) => async (dispatch, getState) => {
  const state = getState();
  const token = state.auth.token;
  console.log("Fetching sentence table data with params:", { fileId, sourceId, targetId, translatorAdminId, status });
  try {
    const url = status !== 'PENDING' ? `api/translatorAdmin/sentences?fileId=${fileId}&sourceId=${sourceId}&targetId=${targetId}&translatorAdminId=${translatorAdminId}` : `api/translatorAdmin/approvedSentences?fileId=${fileId}`;
    const data = await apiClient(
      BASE_URL + url,
      {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        }
      }
    );
    if (data.status === 'success') {
      dispatch(setSentenceTableData(data.data));
    } else {
      dispatch(setSentenceTableData([]));
    }
    return data.data;
  } catch (error) {
    console.error('Error fetching sentence table data:', error);
    dispatch(setSentenceTableData([]));
    return [];
  }
};
